define([
    "./genericParamsModule"
], function (entityModule) {

    "use strict";

    entityModule.controller("GenericParamDefinitionGroupEditionController", ["$scope", "loadingService", "genericParamDataEditionModal", "$translate",
        function ($scope, loadingService, genericParamDataEditionModal, $translate) {

            $scope.genericParametersTableOptions = {
                records: $scope.entityDTO.genericParamDefinitionGroups,
                columns: [{
                    "cell": {
                        template: "<a name='editButton' class='btn mini btn-default' ng-click='editGenericParamDefinitionGroup(record)' style='margin-top:3px'> <span class='fa fa-pencil-square-o'></span> </a>"
                    },
                    width: "28px"
                }, {
                    header: "entity.property.sourceId",
                    cell: "{{ record.sourceId }}",
                    sortBy: "sourceId",
                    cellName: "genericParameterGroupSourceId"
                }, {
                    header: "entity.property.name",
                    cell: "{{ getTranslatableName(record) }}",
                    sortBy: "name",
                    cellName: "genericParameterGroupName"
                }, {
                    header: "entity.property.description",
                    cell: "{{ getTranslatableDescription(record) }}",
                    sortBy: "description",
                    cellName: "genericParameterGroupDescription"
                }]
            };

            $scope.getTranslatableName = function (record) {
                var locale = $translate.use();
                if (locale === "es") {
                    return record.spanishName;
                }
                if (locale === "en") {
                    return record.englishName;
                }
                return record.name;
            };

            $scope.getTranslatableDescription = function (record) {
                var locale = $translate.use();
                if (locale === "es") {
                    return record.spanishDescription;
                }
                if (locale === "en") {
                    return record.englishDescription;
                }
                return record.description;
            };

            $scope.editGenericParamDefinitionGroup = function (definitionGroup) {
                genericParamDataEditionModal.fromDefinitionGroup(definitionGroup, $scope.entityDTO.dto);
            };
        }]);
});